import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("th_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("th_cart", JSON.stringify(items)); }, [items]);

  const add = (product, variant) => {
    setItems((prev) => {
      const key = product.id + (variant || "");
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, {
        key, product_id: product.id, name: product.name, variant: variant || null,
        price: product.price, currency: product.currency, image_url: product.image_url, quantity: 1,
      }];
    });
  };
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const setQty = (key, q) => setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
